import * as React from 'react'
import { Inset, StackChildren, Text, Stack } from '@doordash/design-language'
import { getIsMobile } from '../../../utilities/userAgent'
import StickyBottom from '../../../components/atoms/sticky-bottom'
import { FullHeightWrapper } from '../../../components/organisms/workflow-template/WorkflowTemplate'
import Button from '@doordash/component-button'
import { WorkflowErrorType } from '../../../components/pages/onboarding-workflow/OnboardingWorkflow'

export enum WORKFLOW_ERROR_TYPES {
  DOC_UPLOAD = 'DOC_UPLOAD',
  GENERIC ='GENERIC'
}

type WorkflowErrorProps = {
  error: WorkflowErrorType,
  onRetry: () => void
}

export const WorkflowError: React.FC<WorkflowErrorProps> = ({
  error,
  onRetry
}) => {
  const onClick = () => {
    onRetry()
  }

  const isMobile = getIsMobile()

  const heading = error.type === WORKFLOW_ERROR_TYPES.DOC_UPLOAD ?
    'We’re having trouble processing your documents' :
    'We’re having trouble processing your application'


  const content = error.type === WORKFLOW_ERROR_TYPES.DOC_UPLOAD ?
    'Please take re-take the photos of your documents and try again.' :
    'Please try again later.'

  return (
    <FullHeightWrapper isMobile={isMobile}>
      <Inset size={Inset.Sizes.Large} horizontalSize={Inset.Sizes.XxxSmall}>
        <StackChildren size={StackChildren.Sizes.Large}>
          <Text styles={Text.Styles.Title1}>
            {heading}
          </Text>
          <Text styles={Text.Styles.Body1}>
            {content}
          </Text>
        </StackChildren>
      </Inset>
      <StickyBottom isMobile={isMobile}>
        <Stack size={StackChildren.Sizes.XxSmall}>
          <Button data-testid="ctaButton" onClick={onClick}>
            Retry
          </Button>
        </Stack>
      </StickyBottom>
    </FullHeightWrapper>
  )
}
